import { render, staticRenderFns } from "./house-config.vue?vue&type=template&id=d89ea728"
import script from "./house-config.vue?vue&type=script&lang=js"
export * from "./house-config.vue?vue&type=script&lang=js"
import style0 from "./house-config.vue?vue&type=style&index=0&id=d89ea728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports